export default "__VITE_ASSET__1Bdg5xc5__"